// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__rHiuQ","checkboxGroup":"checkbox_checkboxGroup__C11dP"};